import { SET_USER_PROFILE } from "../constants/action-types";

const user = (state = {}, action) => {
  switch (action.type) {
    case SET_USER_PROFILE:
      return {
        ...state,
        ...action.profile
      }
    default:
      return state;
  }
}

export default user;
